import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-copy-report-template',
  templateUrl: './copy-report-template.component.html',
  styleUrls: ['./copy-report-template.component.scss'],
})
export class CopyReportTemplateComponent implements OnInit {
  @Output() saveCopyReportTemplateEvent = new EventEmitter<any>();

  templateData: any;
  organizationList: any[] = [];
  modalLabel = 'Copy report template';
  copyReportTemplateForm!: FormGroup;
  submitted = false;

  constructor(
    private readonly modal: CustomModalService,
    private readonly formBuilder: FormBuilder
  ) {
    const initialState: any = this.modal?.modalService?.config?.initialState ?? {};
    this.templateData = initialState['templateData'];
    this.organizationList = initialState['organizationList'] ?? [];
    if (initialState['label']) {
      this.modalLabel = initialState['label'];
    }
  }

  ngOnInit(): void {
    this.copyReportTemplateForm = this.formBuilder.group({
      templateName: [
        this.templateData?.templateName ?? '',
        [Validators.required, noWhitespaceValidator, Validators.maxLength(255)],
      ],
      organization: [null, Validators.required],
    });
  }

  commonInputSearch(term: string, item: any) {
    return item?.name?.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (this.copyReportTemplateForm.invalid) return;

    const selectedOrg = this.copyReportTemplateForm.controls['organization'].value;
    const targetOrganizationId =
      selectedOrg?.organizationId ?? selectedOrg?.id ?? selectedOrg;

    const payload = {
      sourceTemplateId: this.templateData?.id,
      targetOrganizationId: Number(targetOrganizationId),
      templateName: (this.copyReportTemplateForm.controls['templateName'].value ?? '').trim(),
    };

    this.saveCopyReportTemplateEvent.emit(payload);
    this.onClose();
  }
}
